import { AimsCommonTableHeader, AimsCommonTablePermissions, TableRowDelete, TableRowUpdate } from '@aims/common-components';
import { X } from '@angular/cdk/keycodes';
import { Component, OnInit } from '@angular/core';
import { Validators } from '@angular/forms';
import { Observable } from 'rxjs';
import { filter } from 'rxjs/operators';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import { TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service';
import { QcReportSchedule, QcReportScheduleAsRequired, QcReportScheduleSchedule } from 'src/models';

@Component({
  selector: 'app-qc-master-report-listing',
  templateUrl: './qc-master-report-listing.component.html',
  styleUrls: ['./qc-master-report-listing.component.css']
})
export class QcMasterReportListingComponent implements OnInit {

tablePermissions: AimsCommonTablePermissions = {
    create: this.permissions.canCreate(this.permissions.ComponentID.QualityControlConfig),
    update: this.permissions.canUpdate(this.permissions.ComponentID.QualityControlConfig),
    delete: false,
  };
  tableHeader: AimsCommonTableHeader[] = [
    { key: 'rowExpand', label: '', type: 'rowExpand', filter: false },
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'reportScheduleNumber', label: 'Number', type: 'string', width: 100, validatorOrOpts: [Validators.required, Validators.maxLength(20)] },
    { key: 'reportScheduleName', label: 'Name', type: 'string', width: 300, validatorOrOpts: [Validators.required, Validators.maxLength(100)] },
    { key: 'responsibleManagerId', label: 'Type', type: 'dynamic', width: 200, filterType: 'dynamic',
      validatorOrOpts: { validators: Validators.required },
      events: { filterAndSortCompare: (term, el) => term === el.responsibleManagerId } },
    { key: 'reportScheduleFrequencyId', label: 'Frequency', type: 'dynamic', width: 200, filterType: 'dynamic',
      validatorOrOpts: { validators: Validators.required },
      events: { filterAndSortCompare: (term, el) => term === el.reportScheduleFrequencyId } },
    { key: 'dayDue', label: 'Day of Month Due', type: 'number', width: 100, validatorOrOpts: [Validators.maxLength(2), Validators.min(1), Validators.max(31)] },
    { key: 'active', label: 'Active', type: 'boolean', width: 100, filterType: 'boolean' },
  ];

  defaultItem: QcReportSchedule = this.newReportSchedule();
  newReportSchedule() {
    let retVal = new QcReportSchedule();
    retVal.reportScheduleFrequencyId = null;
    retVal.responsibleManagerId = null;
    retVal.active = true;
    return retVal;
  }

  /// SubTables

  // As Required sub table
  asRequiredTableHeader: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'siteId', label: 'Site', type: 'dynamic', width: 200, filterType: 'dynamic',
      validatorOrOpts: { validators: Validators.required },
      events: { filterAndSortCompare: (term, el) => term === el.siteId } },
    { key: 'inspectionSequenceId', label: 'Sequence', type: 'dynamic', width: 200, filterType: 'dynamic',
      validatorOrOpts: { validators: Validators.required },
      events: { filterAndSortCompare: (term, el) => term === el.inspectionSequenceId } },
    { key: 'trackingNumber', label: 'Tracking Number', type: 'string', width: 100, validatorOrOpts: [Validators.maxLength(50)] },
    { key: 'dateDue', label: 'Date Due', type: 'date', width: 100, validatorOrOpts: [Validators.required] },
  ];
  asRequiredTablePermissions: AimsCommonTablePermissions = {
    create: this.permissions.canCreate(this.permissions.ComponentID.ReportSchedules),
    update: this.permissions.canUpdate(this.permissions.ComponentID.ReportSchedules),
    delete: this.permissions.canUpdate(this.permissions.ComponentID.ReportSchedules),
  }

  defaultAsRequiredItem: QcReportScheduleAsRequired= this.newARSchedule();
  newARSchedule() {
    let retVal = new QcReportScheduleAsRequired();
    return retVal;
  }

  // Scheduled sub table
  scheduledTableHeader: AimsCommonTableHeader[] = [
    { key: 'editButton', label: 'Edit', type: 'editButton', filter: false },
    { key: 'dateDue', label: 'Date Due', type: 'date', width: 100, validatorOrOpts: [Validators.required] },
  ];
  scheduledTablePermissions: AimsCommonTablePermissions = {
    create: this.permissions.canCreate(this.permissions.ComponentID.ReportSchedules),
    update: this.permissions.canUpdate(this.permissions.ComponentID.ReportSchedules),
    delete: this.permissions.canUpdate(this.permissions.ComponentID.ReportSchedules),
  }

  defaultScheduledItem: QcReportScheduleSchedule = this.newRSSchedule();
  newRSSchedule() {
    let retVal = new QcReportScheduleSchedule();
    return retVal;
  }


  constructor(private transferHttp: TransferHttpService,public permissions: PermissionsService) { }

  asRequiredFreq: number = 7; // Frequency
  reportScheduleArray: Array<any>;
  responsibleManagerValues = this.transferHttp.getSingle('QualityControl/GetResponsibleManagersForPopUp');
  reportFreqValues = this.transferHttp.getSingle('QualityControl/GetReportScheduleFrequencyForPopUp');
  asRequiredSchedules = this.transferHttp.getSingle('QualityControl/GetReportScheduleAsRequired');
  siteValues = this.transferHttp.getHot(`Common/GetAllSitesForDropdown`);
  inspectionSequenceValues = this.transferHttp.getSingle('QualityControl/GetInspectionSequencesForPopUp');

  public handleRowUpdate(update: TableRowUpdate): void {
    const updatedLineItem: QcReportSchedule = update.newRow as QcReportSchedule;
    this.saveItem(updatedLineItem);
  }

  public handleRowAdded(update: TableRowUpdate) {
    const item: QcReportSchedule = update.newRow as QcReportSchedule;
    this.saveItem(item);
  }

  public handleRowDelete(deleted: TableRowDelete) {
  }

  currentlyExpandedReportSchedule:QcReportSchedule;

  public handleRowExpand(element: any) {
    const rs: QcReportSchedule = element as QcReportSchedule;
    this.currentlyExpandedReportSchedule = rs;
  }

  saveItem(item) {
    this.transferHttp.save('QualityControl/SaveReportSchedules', item, false).subscribe(show => {
      if (!show) {
        this.loadItems();
      }
    });
  }

  loadItems() {
    this.transferHttp.getSingle('QualityControl/GetReportSchedule').subscribe(rs => {
      this.reportScheduleArray = rs;
    });
  }

  // as Required functions
  isAsRequired(data: QcReportSchedule): boolean {
    let retVal = false;
    if (data.reportScheduleFrequencyId == this.asRequiredFreq) {
      retVal = true;
    }
    return retVal;
  }

  public handleAsRequiredRowUpdate(update: TableRowUpdate): void {
    const updatedLineItem: QcReportScheduleAsRequired = update.newRow as QcReportScheduleAsRequired;
    this.saveAsRequiredItem(updatedLineItem).subscribe(show => {
      if (!show) {
        this.currentlyExpandedReportSchedule.qcReportScheduleAsRequired[update.index] = updatedLineItem;
        this.currentlyExpandedReportSchedule.qcReportScheduleAsRequired = [...this.currentlyExpandedReportSchedule.qcReportScheduleAsRequired];
      }
    });
  }

  public handleAsRequiredRowAdd(update: TableRowUpdate) {
    const item: QcReportScheduleAsRequired = update.newRow as QcReportScheduleAsRequired;
    item.reportScheduleId = this.currentlyExpandedReportSchedule?.reportScheduleId ;
    this.saveAsRequiredItem(item).subscribe(show => {
      if (!show) {
        this.currentlyExpandedReportSchedule.qcReportScheduleAsRequired = [item, ...this.currentlyExpandedReportSchedule.qcReportScheduleAsRequired];
      }
    });
  }

  public handleAsRequiredRowDelete (deleted: TableRowDelete) {
    const item: QcReportScheduleAsRequired = deleted.row as QcReportScheduleAsRequired;

    this.transferHttp.delete(`QualityControl/DeleteAsRequiredReportSchedule?reportScheduleAsRequiredId=${item.reportScheduleAsRequiredId}`).subscribe(numDeleted => {
        if (numDeleted == 1) {
          this.currentlyExpandedReportSchedule.qcReportScheduleAsRequired.splice(deleted.index, 1);
          this.currentlyExpandedReportSchedule.qcReportScheduleAsRequired = [...this.currentlyExpandedReportSchedule.qcReportScheduleAsRequired];
        }
      });
  }

  saveAsRequiredItem(item) {
    return this.transferHttp.save('QualityControl/SaveAsRequiredReportSchedules', item, false)
  }

  // Scheduled functions
  public handleScheduledRowUpdate(update: TableRowUpdate): void {
    const updatedLineItem: QcReportScheduleSchedule = update.newRow as QcReportScheduleSchedule;
    this.saveScheduledItem(updatedLineItem).subscribe(show => {
      if (!show) {
        this.currentlyExpandedReportSchedule.qcReportScheduleSchedule[update.index] = updatedLineItem;
        this.currentlyExpandedReportSchedule.qcReportScheduleSchedule = [...this.currentlyExpandedReportSchedule.qcReportScheduleSchedule];
      }
    });
  }

  public handleScheduledRowAdd(update: TableRowUpdate) {
    const item: QcReportScheduleSchedule = update.newRow as QcReportScheduleSchedule;
    item.reportScheduleId = this.currentlyExpandedReportSchedule?.reportScheduleId;
    this.saveScheduledItem(item).subscribe(show => {
      if (!show) {
        this.currentlyExpandedReportSchedule.qcReportScheduleSchedule = [item, ...this.currentlyExpandedReportSchedule.qcReportScheduleSchedule];
      }
    });
  }

  public handleScheduledRowDelete (deleted: TableRowDelete) {
    const item: QcReportScheduleSchedule = deleted.row as QcReportScheduleSchedule;

    this.transferHttp.delete(`QualityControl/DeleteReportScheduleSchedule?reportScheduleSubmitId=${item.reportScheduleSubmitId}`).subscribe(numDeleted => {
        if (numDeleted == 1) {
          this.currentlyExpandedReportSchedule.qcReportScheduleSchedule.splice(deleted.index, 1);
          this.currentlyExpandedReportSchedule.qcReportScheduleSchedule = [...this.currentlyExpandedReportSchedule.qcReportScheduleSchedule];
        }
      });
  }

  saveScheduledItem(item) {
    return this.transferHttp.save('QualityControl/SaveReportScheduleSchedules', item, false)
  }

  ngOnInit(): void {
    this.loadItems();
  }

}
